import { featuredComics } from "@/mocks/comicData";

function Featured() {
  return (
    <section id="featured" className="container-page py-16 md:py-20">
      <div className="mb-10 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
        <div>
          <span className="eyebrow">
            <i className="ri-fire-line"></i>
            热门笑点
          </span>
          <h2 className="section-title mt-3">今天也要笑出鹅叫</h2>
        </div>
        <a
          href="#collections"
          onClick={(e) => {
            e.preventDefault();
            document.getElementById("collections")?.scrollIntoView({ behavior: "smooth" });
          }}
          className="inline-flex items-center gap-1 text-sm font-bold text-primary-600 hover:text-primary-700"
        >
          查看更多合集
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {featuredComics.map((comic) => (
          <article
            key={comic.id}
            className="group flex flex-col overflow-hidden rounded-2xl bg-background-100"
          >
            <div className="relative h-48 overflow-hidden md:h-52">
              <img
                src={comic.img}
                alt={`${comic.title} - 大黄丫头漫画搞笑片段`}
                className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                {comic.tag}
              </span>
            </div>

            <div className="flex flex-1 flex-col p-5">
              <div className="mb-1 flex items-center justify-between">
                <h3 className="font-heading text-lg text-foreground-950 group-hover:text-primary-700">
                  {comic.title}
                </h3>
                <span className="text-xs font-bold text-accent-500">{comic.chapter}</span>
              </div>
              <p className="mt-1 flex-1 text-sm leading-relaxed text-foreground-600">
                {comic.subtitle}
              </p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-thumb-up-line"></i>
                  {(comic.likes / 1000).toFixed(1)}w
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-chat-3-line"></i>
                  {comic.comments} 条讨论
                </span>
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className="ri-play-fill"></i>
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Featured;